import { useState } from "react";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { formatDate } from "@/lib/services";
import { useServices } from "@/context/ServicesContext";

export const NoticeButton = ({ s, compact = false, onDone }) => {
  const { messaging, bump } = useServices();
  const [busy, setBusy] = useState(false);
  const via = messaging?.channel === "whatsapp" ? "WhatsApp" : "e-mail";

  const send = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post("/messages/notice", { service_id: s.id });
      if (data.status === "enviada") toast.success(`Aviso da visita de ${formatDate(s.execution_date)} enviado por ${via} para ${data.to}.`);
      else toast.error(data.error || `Situação do aviso: ${data.status}`);
      onDone ? onDone() : bump();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  const Icon = busy ? Loader2 : BellRing;
  return (
    <Button size="sm" variant="outline" disabled={busy} onClick={send} title={`Avisar o cliente do agendamento por ${via}`}
      className={`${compact ? "h-8 w-8 p-0" : "h-8 px-3 text-xs"} rounded-full border-indigo-400/50 bg-transparent text-indigo-200`} data-testid={`notice-button-${s.id}`}>
      <Icon className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} />{!compact && <span className="ml-1">Avisar agendamento</span>}
    </Button>
  );
};
